import { ActionSet, createActionSet } from '../../redux-helpers';

// These are used by components to request from store mainly
export const GET_ORGANISATION_BY_ID: ActionSet = createActionSet('GET_ORGANISATION_BY_ID');
export const GET_ORGANISATIONS: ActionSet = createActionSet('GET_ORGANISATIONS');
export const DELETE_ORGANISATION: ActionSet = createActionSet('DELETE_ORGANISATION');
export const ACTIVATE_PRODUCT: ActionSet = createActionSet('ACTIVATE_PRODUCT');
